/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

export default {
  // Example nav actions
  REGISTER_SECTION: 'REGISTER_SECTION',
  UNREGISTER_SECTION: 'UNREGISTER_SECTION',

  // Locale actions
  TOGGLE_LOCALE: 'TOGGLE_LOCALE',
};
